import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import { CertificatesState } from './CertificatesState';
import { HomeStates } from './HomeStates';
import { TrainingState } from './TrainingsState';
import { PersonalizationState } from './PersonalizationState';
import { InformationState } from './InformationState';
import { UBRState } from './UBRState';
import { ProfileState } from './ProfileState';
import { LoaderState } from './LoaderState';
import { UsageOverviewState } from './UsageOverviewState';

export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
        certificates_state: CertificatesState(),
        home_state: HomeStates(),
        training_state: TrainingState(),
        personalization_state: PersonalizationState(),
        information_state: InformationState(),
        ubr_state: UBRState(),
        profile_state: ProfileState(),
        loader_state: LoaderState(),
        usage_state: UsageOverviewState(),
    }
}